import { Component, OnInit , EventEmitter , Output} from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../../../shared/services/dialog.service';
import { Utility } from '../../../../common/utility';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { Page } from '../../../../models/list/page.model';

import { EditGroupPopupComponent } from './edit-group-popup.component';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';
import { ConsultationType, ConsultationValue } from '../../../../models/consultation/consultation.model';
import { GroupWaitingService } from './group.service';
import { ConsultationStatusPopupComponent } from '../../consultation-status/consultation-status-popup';
import { TMBDataTableComponent } from '../../../../components/data-table/data-table.component';
import { SharedService } from '../../../../shared/services/share.services';

@Component({
  selector: 'app-group-list',
  templateUrl: 'group-list.component.html',
  providers: [GroupWaitingService]
})

export class GroupListComponent extends TMBDataTableComponent implements OnInit {
  @Output() refeshList: EventEmitter<any> = new EventEmitter();
  public consultationValue = ConsultationValue;
  public isCreateSuccess;
  public dataRow = new Array<GroupWaitingModel>();

  constructor(
    public utility: Utility,
    public groupWaitingService: GroupWaitingService,
    public dialogService: DialogService,
    public sharedService: SharedService,
    private router: Router
  ) {
    super(sharedService);
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  setPage(pageInfo, isUpdateLastedDate = true) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1
    };
    this.groupWaitingService.getWaitingGroupList(param).subscribe
      (result => {
        if (result) {
          const data = result.json();
          this.dataRow = data['list'];
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          if (this.page.pageNumber + 1 > this.page.totalPages) {
            this.page.pageNumber = this.page.totalPages > 0 ? (this.page.totalPages - 1) : 0;
          }
        }
      });
  }

  onConsultationGroup(row) {
    const data = {
      status: row.status,
      id: row.groupId,
      isGroup: true,
      lastedStep : row.step
    };
    this.dialogService.openComponentDialog(ConsultationStatusPopupComponent, data, { 'width': '400px' });
  }

  // Edit Group popup
  onEditGroup(groupId: string) {
    const data = {
      groupId: groupId,
    };
    this.dialogService.openComponentDialog(EditGroupPopupComponent, data, { 'width': '800px' }).subscribe
      (result => {
        this.reloadPage(this.page.pageNumber, this.dataRow);
        this.refeshList.emit();
      });
  }

  onRemoveGroup(id: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.groupConsultant.removeGroup }).subscribe
    (result => {
        if (result) {
        // if user click yes then call API to remove group
        this.groupWaitingService.removeGroupWaitting(id).subscribe(
          deleteResult => {
            if (deleteResult) {
              // remove group success then reload list
              this.reloadPage(this.page.pageNumber, this.dataRow, true);
              this.refeshList.emit();
            }
          }
        );
      }
    });
  }
  refreshPage(isUpdateLastedDate = false) {
    this.setPage({ offset: this.page.pageNumber }, isUpdateLastedDate);
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group/group-list.component.ts